/* eslint new-cap:0 */
/* eslint func-names:0 */
/* eslint no-throw-literal:0 */
/* eslint keyword-spacing:0 */
/* eslint generator-star-spacing:0 */
window.cadesplugin_load_timeout = 5000;
import { fromPairs, isNil, merge, reject as lodashReject, trim } from 'lodash';
import { encode } from './base64';
import moment from 'moment';
import oidMap from '../vipnet/oidMap';
import cryptoConstants from 'constants/crypto';

import './crypto.scss';

const CAPICOM_CURRENT_USER_STORE = 2;
const CAPICOM_MY_STORE = 'My';
const CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2;
const CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
const CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME = 0;

export async function importCadesplugin_api() {
  await import('./cadesplugin_api');
  return await window.cadesplugin;
}

export const includes = async (certSubjectName) => {
  await importCadesplugin_api();
  return new Promise((resolve, reject) => {
    window.cadesplugin.async_spawn(
      function* (args) {
        try {
          const oStore = yield window.cadesplugin.CreateObjectAsync('CAPICOM.Store');

          yield oStore.Open(
            CAPICOM_CURRENT_USER_STORE,
            CAPICOM_MY_STORE,
            CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
          );

          const CertificatesObj = yield oStore.Certificates;
          window.console.log(CertificatesObj);
          const oCertificates = yield CertificatesObj.Find(
            CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
            certSubjectName,
          );

          const Count = yield oCertificates.Count;

          yield oStore.Close();
          args[1](Count !== 0);
        } catch (err) {
          args[2]('Failed to create signature. Error: ' + getErrorMessage(err));
        }
      },
      certSubjectName,
      resolve,
      reject,
    );
  });
};

const getErrorMessage = (e) => {
  let err = e.message;

  if (!err) {
    err = e;
  } else if (e.number) {
    err += ' (' + e.number + ')';
  }
  return err;
};
export const baseEncode = (document) => {
  return encode(document);
};

export const getCertForServer = async (certSubjectName) => {
  await importCadesplugin_api();
  return new Promise((resolve, reject) => {
    window.cadesplugin.async_spawn(
      function* (args) {
        try {
          const oStore = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.Store');

          yield oStore.Open();
          const oCertificates = yield oStore.Certificates;
          const oCertificate = yield oCertificates.Find(
            CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
            certSubjectName,
          );

          const Count = yield oCertificates.Count;

          if (Count === 0) {
            args[3]('Failed to create signature. Certificate not found:' + args[0]);
            return;
          }

          const Certificate = yield oCertificate.Item(1);

          const sertttt = yield Certificate.Export(0);
          yield oStore.Close();
          args[0](sertttt);
        } catch (err) {
          args[1]('Failed to get certificates ' + getErrorMessage(err));
        }
      },
      resolve,
      reject,
    );
  });
};
export const getCertList = async () => {
  await importCadesplugin_api();
  return new Promise((resolve, reject) => {
    window.cadesplugin.async_spawn(
      function* (args) {
        try {
          const oStore = yield window.cadesplugin.CreateObjectAsync('CAPICOM.Store');

          yield oStore.Open();
          const oCertificates = yield oStore.Certificates;
          const certCount = yield oCertificates.Count;

          if (certCount === 0) {
            throw 'Certificate not found: ' + args[0];
          }

          const lst = [];
          for (let i = 1; i <= certCount; i++) {
            let oCertificate;

            try {
              oCertificate = yield oCertificates.Item(i);
            } catch (ex) {
              throw 'Ошибка при перечислении сертификатов: ' + args[0];
            }

            const oOpt = {};

            try {
              let ValidToDate = new Date(yield oCertificate.ValidToDate); // ie returns invalid date object
              let ValidFromDate = new Date(yield oCertificate.ValidFromDate);
              const HasPrivateKey = yield oCertificate.HasPrivateKey();
              let IsValid = yield oCertificate.IsValid();
              const PublicKey = yield oCertificate.PublicKey();
              const Algorithm = yield PublicKey.Algorithm;
              const algorithmOID = yield Algorithm.Value;

              IsValid = yield IsValid.Result;
              ValidToDate = moment(ValidToDate);
              ValidFromDate = moment(ValidFromDate);
              oOpt.ValidToDate = ValidToDate;
              oOpt.ValidFromDate = ValidFromDate;
              oOpt.isValid = IsValid;
              oOpt.HasPrivateKey = HasPrivateKey;
              oOpt.subject = yield oCertificate.SubjectName;
              oOpt.hasGOSTAlgorithm =
                algorithmOID === cryptoConstants.GOST_ALGORITHM_OID ||
                algorithmOID === cryptoConstants.GOST_ALGORITHM_OID_2001 ||
                algorithmOID === cryptoConstants.GOST_ALGORITHM_OID_512;

              let subjectArray = oOpt.subject.split(',');

              if (subjectArray.length === 1) {
                subjectArray = oOpt.subject.split(';');
              }
              oOpt.subjectObj = merge(
                {},
                ...subjectArray.map((item) => {
                  const clearedItem = trim(item);
                  return fromPairs([clearedItem.split('=')]);
                }),
              );

              oOpt.subjectObj.SN = oOpt.subjectObj.SN || '';
              oOpt.subjectObj.G = oOpt.subjectObj.G || '';
              oOpt.subjectObj.INN =
                oOpt.subjectObj.INN ||
                oOpt.subjectObj['ИНН'] ||
                oOpt.subjectObj[`OID.${oidMap.INN}`];
              oOpt.subjectObj.OGRN =
                oOpt.subjectObj.OGRN ||
                oOpt.subjectObj['ОГРН'] ||
                oOpt.subjectObj[`OID.${oidMap.OGRN}`];

              oOpt.label = lodashReject(
                [
                  oOpt.subjectObj.O,
                  `${oOpt.subjectObj.SN} ${oOpt.subjectObj.G}`,
                  oOpt.subjectObj.T,
                ],
                isNil,
              ).join(', ');

              oOpt.CN = yield oCertificate.GetInfo(CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME);
            } catch (ex) {
              // throw('Ошибка при получении свойства SubjectName: ' + args[0]);
              continue;
            }

            try {
              oOpt.value = yield oCertificate.Thumbprint;
            } catch (ex) {
              throw 'Ошибка при получении свойства Thumbprint: ' + args[0];
            }

            lst.push(oOpt);
          }

          yield oStore.Close();
          args[0](lst);
        } catch (err) {
          args[1]('Failed to create list of certificates. Error: ' + getErrorMessage(err));
        }
      },
      resolve,
      reject,
    );
  });
};

export const signCreate = async (certSubjectName, dataToSign, isDateEncode = false) => {
  await importCadesplugin_api();
  return new Promise((resolve, reject) => {
    window.cadesplugin.async_spawn(
      function* (args) {
        try {
          //почему CAPICOM ??
          const oStore = yield window.cadesplugin.CreateObjectAsync('CAPICOM.Store');
          // const oStore = yield cadesplugin.CreateObjectAsync('CAdESCOM.Store');

          yield oStore.Open(
            CAPICOM_CURRENT_USER_STORE,
            CAPICOM_MY_STORE,
            CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
          );

          const CertificatesObj = yield oStore.Certificates;

          const oCertificates = yield CertificatesObj.Find(
            CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
            certSubjectName,
          );

          const Count = yield oCertificates.Count;

          if (Count === 0) {
            args[3]('Failed to create signature. Certificate not found:' + args[0]);
            return;
          }

          const oCertificate = yield oCertificates.Item(1);

          const oSigner = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner');

          yield oSigner.propset_Options
            ? yield oSigner.propset_Options(
                window.cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN,
              )
            : yield (oSigner.Options = window.cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN);

          yield oSigner.propset_Certificate
            ? yield oSigner.propset_Certificate(oCertificate)
            : yield (oSigner.Certificate = oCertificate);

          const oSignedData = yield window.cadesplugin.CreateObjectAsync(
            'CAdESCOM.CadesSignedData',
          );
          const data = isDateEncode ? args[1] : encode(args[1]);

          yield oSignedData.propset_ContentEncoding
            ? yield oSignedData.propset_ContentEncoding(
                window.cadesplugin.CADESCOM_BASE64_TO_BINARY,
              )
            : (oSignedData.ContentEncoding = window.cadesplugin.CADESCOM_BASE64_TO_BINARY);

          yield oSignedData.propset_Content
            ? yield oSignedData.propset_Content(data)
            : yield (oSignedData.Content = data);

          const sSignedMessage = (yield oSignedData.SignCades(
            oSigner,
            window.cadesplugin.CADESCOM_CADES_BES,
            true,
            0,
          )).replace(/(\r\n|\n|\r)/gm, '');

          yield oStore.Close();
          args[2](sSignedMessage);
        } catch (err) {
          args[3]('Failed to create signature. Error: ' + getErrorMessage(err));
        }
      },
      certSubjectName,
      dataToSign,
      resolve,
      reject,
    );
  });
};

export const getCryptoProVersion = async () => {
  await importCadesplugin_api();
  return new Promise((resolve, reject) => {
    window.cadesplugin.async_spawn(
      function* (args) {
        try {
          const oAbout = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.About');
          const version = {};
          version.version = yield oAbout.Version;
          version.CSPName = yield oAbout.CSPName();

          args[0](version);
        } catch (err) {
          args[1]('CSP не установлен. Error: ' + getErrorMessage(err));
        }
      },
      resolve,
      reject,
    );
  });
};
